
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dtaType' })
export class DtaTypePipe implements PipeTransform {
  transform(value: unknown): string {
    console.debug(value);
    if (value === 5 || value === '5') {
      return 'SGB V';
    }
    if (value === 11 || value === '11') {
      return 'SGB XI';
    }
    return '';
  }
}
